import { useQuery } from '@tanstack/react-query';
import type { Locale } from '@/modules/i18n/i18n.models';
import type { Sidepanel } from '@/payload/types';

async function fetchSidepanel(slug: string, locale: Locale): Promise<Sidepanel> {
	const response = await fetch(`/api/sidepanels/${slug}?locale=${locale}`);

	if (!response.ok) {
		throw new Error('Failed to fetch sidepanel');
	}

	return response.json();
}

export default function useSidePanel(slug: string | null, locale: Locale, initialData?: Sidepanel) {
	return useQuery<Sidepanel>({
		queryKey: ['sidepanel', slug, locale],
		queryFn: () => fetchSidepanel(slug as string, locale),
		staleTime: 1000 * 60 * 5, // Cache for 5 minutes
		enabled: !!slug,
		initialData,
		// This data is preloaded by the server-rendered page, then marked stale so the client
		// refetches on mount without waiting for the page cache to expire.
		initialDataUpdatedAt: initialData ? 0 : undefined,
	});
}
